import { useEffect } from "react";
import { SELECT_TYPE, SWITCH_TYPE, TEXT_TYPE } from "../../constants/webapp";
import { useFirebase } from "../firebase/useFirebase";
import { ROLES_API } from "../../constants/api";
import { addSelectItem } from "../../utils/helpers";

export const useUsersForm = () => {
  const { getData, data } = useFirebase();

  useEffect(() => {
    getData(ROLES_API);
  }, []);

  const fields = [
    {
      label: "uname",
      type: TEXT_TYPE,
      required: true,
      // props: { disabled: true },
    },
    {
      label: "email",
      type: TEXT_TYPE,
      required: true,
      props: { disabled: true },
    },
    {
      label: "is staff",
      type: SWITCH_TYPE,
    },
    {
      label: "is active",
      type: SWITCH_TYPE,
      value: true,
    },
    {
      label: "Role",
      type: SELECT_TYPE,
      required: true,
      options: data?.map((item) => addSelectItem(item, "name")),
    },
  ];

  function onSubmit() {}

  return { fields, onSubmit, api: ROLES_API };
};
